<template>
  <router-view></router-view>
</template>

<script>
import env from "./env.js";
export default {
  name: "App",
  created() {
    document.title = env.applicationName;
  },
};
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  touch-action: manipulation; /* Melhora o desempenho em dispositivos touch */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Fix para iOS Safari */
@supports (-webkit-touch-callout: none) {
  html, body, #app {
    height: -webkit-fill-available;
  }
}

/* Fix para dispositivos mobile */
@media (max-width: 768px) {
  body {
    position: fixed;
    width: 100%;
    height: 100%;
  }
}
</style>